import {
  getApiV1ThreeLetterCodeClientAdminsBranches,
  getGetApiV1ThreeLetterCodeClientAdminsBranchesKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { GetApiV1ThreeLetterCodeClientAdminsBranches200 } from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';

type Args = {
  threeLetterCode: string;
};

type IUseGetClientBranches = (args: Args) => {
  data: GetApiV1ThreeLetterCodeClientAdminsBranches200;
};

/**
 * 事業所一覧取得フック
 *
 * @param threeLetterCode - 企業コード
 */
export const useGetClientBranches: IUseGetClientBranches = ({ threeLetterCode }) => {
  const { data } = useFetch(
    getGetApiV1ThreeLetterCodeClientAdminsBranchesKey(threeLetterCode),
    () => getApiV1ThreeLetterCodeClientAdminsBranches(threeLetterCode),
    { suspense: true }
  );

  return { data };
};
